module.exports = __webpack_public_path__ + "static/SungaiBuloh-14f1beacfbc9851f07aac9802de2c850.png";